import { ActionIcon, Divider } from '@mantine/core'

import AdminContainer from 'src/components/AdminContainer/AdminContainer'
import IconLeftArrow from 'src/icons/IconLeftArrow'

import AdvancedCard from './components/AdvancedCard'
import CallTransferCard from './components/CallTransferCard'
import GeneralCard from './components/GeneralCard'
import KnowledgeBaseCard from './components/KnowledgeBaseCard'
import QualificationQuestionsCard from './components/QualificationQuestionsCard'

const VoiceAgentDetailsPage = ({
  voiceAgent,
  setSelectedVoiceAgent,
  refetchVoiceAgents,
}) => {
  return (
    <div className="flex h-full flex-col gap-4 overflow-auto">
      <div className="flex flex-row items-center gap-2">
        <ActionIcon
          variant="subtle"
          color="gray"
          onClick={() => setSelectedVoiceAgent(null)}
        >
          <IconLeftArrow className="fill-none stroke-doubleNickel-gray-700" />
        </ActionIcon>
        <div className="text-base font-medium text-doubleNickel-gray-900">
          {voiceAgent.name}
        </div>
      </div>

      <Divider />

      <div className="flex h-full flex-col gap-4 overflow-auto pb-6">
        <GeneralCard
          voiceAgent={voiceAgent}
          refetchVoiceAgents={refetchVoiceAgents}
        />
        <KnowledgeBaseCard voiceAgent={voiceAgent} />
        <AdminContainer>
          <QualificationQuestionsCard
            voiceAgent={voiceAgent}
            refetchVoiceAgents={refetchVoiceAgents}
          />
          <CallTransferCard
            voiceAgent={voiceAgent}
            refetchVoiceAgents={refetchVoiceAgents}
          />
        </AdminContainer>
        <AdminContainer>
          <AdvancedCard
            voiceAgent={voiceAgent}
            refetchVoiceAgents={refetchVoiceAgents}
          />
        </AdminContainer>
      </div>
    </div>
  )
}

export default VoiceAgentDetailsPage
